import React from 'react';

const PcbInstructions = () => {
  const instructions = [
    {
      img: Spree.image_assets.pcb_instruction_one,
      title: 'Fill out the form',
      description: 'Enter the circuit board specs and click on the quote button',
    },
    {
      img: Spree.image_assets.pcb_instruction_two,
      title: 'Select a price from price matrix',
      description: 'Select the price based on quantity and leadtime',
    },
    {
      img: Spree.image_assets.pcb_instruction_three,
      title: 'Upload your gerber files',
      description: 'Gerber files must be compressed in Zip format',
    },
  ];

  return (
    <div className="row instructions">
      {instructions.map((instruction, index) => (
        <div className="col-md-4 instruction" key={index}>
          <img src={instruction.img} className="d-block mx-auto" alt={instruction.title} />
          <div className="instruction-title">
            <span className="instruction-icon">{index + 1}</span>
            <span>{instruction.title}</span>
          </div>
          <p className="instruction-description">{instruction.description}</p>
        </div>
      ))}
    </div>
  );
};

export default PcbInstructions;
